function roundUp(num, precision) {
  precision = Math.pow(10, precision);
  return Math.ceil(num * precision) / precision;
}

function numberFormat(number, decimals, dec_point, thousands_sep) { // Format a number with grouped thousands
  var i, j, kw, kd, km;

  // input sanitation & defaults
  if (isNaN(decimals = Math.abs(decimals))) {
      decimals = 2;
  }
  if (dec_point == undefined) {
      dec_point = ",";
  }
  if (thousands_sep == undefined) {
      thousands_sep = ".";
  }

  i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

  if ((j = i.length) > 3) {
      j = j % 3;
  } else {
      j = 0;
  }

  km = (j ? i.substr(0, j) + thousands_sep : "");
  kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
  kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

  return km + kw + kd;
}

$(document).ready(function() {

  function addCreatedVariantToCart(options) {
      var retryDelay = 10000;
      var throttleDelay = 60000;

      function attemptAdd() {
          $.ajax({
              type: 'POST',
              url: window.Shopify.routes.root + 'cart/add.js',
              data: options.data,
              dataType: 'json',
              success: options.success,
              error: function(response) {
                  var error = response.responseJSON || {};
                  var message = String(error.description || error.message || '');
                  // New variants can reach the Cart API after creation has succeeded.
                  var unavailable = /ausverkauft|sold out|cannot find variant|\u00e9puis\u00e9|variante introuvable/i.test(message);

                  if (response.status === 429) {
                      var retryAfter = response.getResponseHeader('Retry-After');
                      var cooldown = throttleDelay;

                      if (retryAfter) {
                          var retryAfterSeconds = Number(retryAfter);
                          var retryAfterDelay = isFinite(retryAfterSeconds)
                              ? retryAfterSeconds * 1000
                              : Date.parse(retryAfter) - Date.now();

                          if (isFinite(retryAfterDelay)) {
                              cooldown = Math.max(cooldown, retryAfterDelay);
                          }
                      }

                      console.warn('Shopify is rate-limiting cart additions. Retrying in ' + Math.ceil(cooldown / 1000) + ' seconds.');
                      setTimeout(attemptAdd, cooldown);
                      throttleDelay = Math.min(throttleDelay * 2, 300000);
                      retryDelay = 30000;
                      return;
                  }

                  if (response.status === 422 && unavailable) {
                      setTimeout(attemptAdd, retryDelay);
                      retryDelay = Math.min(retryDelay * 2, 30000);
                      return;
                  }

                  options.error(response);
              }
          });
      }

      attemptAdd();
  }

  function handleCartError(response) {
      console.error('Product creation or cart addition failed:', response);
      $('[data-add-to-cart-trigger], .fabric-sample > button').removeClass('disabled button_loading');
      $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span, .fabric-sample > button i, .fabric-sample > button span')
          .removeClass('zoomOut').show();

      var error = response.responseJSON || response;
      var message = error.description || error.message || 'Der Artikel konnte nicht zum Warenkorb hinzugef\u00fcgt werden. Bitte versuchen Sie es erneut.';
      var warning = $('[data-product-form] .cart-warning');

      if (warning.length) {
          warning.empty().append($('<p class="cart-warning__message animated bounceIn">').text(message));
      } else {
          window.alert(message);
      }
  }

  var currentPrice = function() {
      return parseFloat($('.purchase-details .price .money').text().split(' ')[1]);
  }
  
  var currentComparePrice = function() {
      return parseFloat($('.purchase-details .compare-at-price .money').text().split(' ')[1]);
  }

  var originalPrice = parseFloat($('.price-ui .price .money').text().split(' ')[1]);

  var originalComparePrice = parseFloat($('.price-calculator .compare-at-price .money').text().split(' ')[1]);

  var currentQuantity = function() {
      return $(".quantityPrice .quantity-input").val();
  }
  var previousQuantity = 1;

  var inventory = JSON.parse($('[data-product-form]').attr('data-variant-inventory').replace('[', '').replace(']', ''));

  
  $('.color-swatches .swatch.opener').on('click', function() {
      $('.color-swatches .swatch').show();
      $('.color-swatches .swatch.opener').hide();
  });


  $(".quantityPrice .control").on('click change keyUp', function(e) {
      if ($('#length_bar').val() != '') {
          if ($('#length_bar').length === 0) {
              if (inventory.inventory_policy === 'deny' && $('.quantityPrice input.quantity-input.quantity-element').val() >= inventory.inventory_quantity) {
                  e.preventDefault();
                  $('[data-update-quantity="plus"]').attr('disabled', 'disabled');
              }
          }
      }

      if ($('#length').val() != '') {
          if ($('#length').length === 0) {
              if (inventory.inventory_policy === 'deny' && $('.quantityPrice input.quantity-input.quantity-element').val() >= inventory.inventory_quantity) {
                  e.preventDefault();
                  $('[data-update-quantity="plus"]').attr('disabled', 'disabled');
              }
          }
      }

      if ($('#length_wave').val() != '') {
          if ($('#length_wave').length === 0) {
              if (inventory.inventory_policy === 'deny' && $('.quantityPrice input.quantity-input.quantity-element').val() >= inventory.inventory_quantity) {
                  e.preventDefault();
                  $('[data-update-quantity="plus"]').attr('disabled', 'disabled');
              }
          }
      }

      //console.log('previousQuantity',previousQuantity, "currentPrice",currentPrice())

      setTimeout(function() {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat((currentPrice() / previousQuantity) * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat((currentComparePrice() / previousQuantity) * currentQuantity(), 2, '.', ''));
          previousQuantity = currentQuantity();
      }, 300);

  });

  var new_product_price = 0;
  var verkauft_als_stoff = 'nein';

  var stoffmenge = 0;

  var buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain');


  setTimeout(() => {
      buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain')
      if (buy_custom_curtain.length) {
          buy_custom_curtain.attr('disabled', 'disabled');
      }
  }, 500);


  $("#height, #length, input[name='accesories'], input[name='set'], input[name='minMax'], input[name='saum']").on('keyup change', function() {
      var width_value = 0;

      if ($('#length').val() != '') {
          width_value = $('#length').val();
      }

      var buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain');
      var height_value = $('#height').val()||0;
      var curtain_set_pair = $('#pair').is(":checked");
      var curtain_set_piece = $('#piece').is(":checked");

      var curtain_set_flach = $('#flach').is(":checked");
      var curtain_set_einfache_falte = $('#einfache_falte').is(":checked");
      var curtain_set_rundfalte = $('#rundfalte').is(":checked");
      var curtain_set_wave = $('#wave').is(":checked");

      var curtain_set_MaxiVS57 = $('#MaxiVS57').is(":checked");
      var curtain_set_Piccolo = $('#Piccolo').is(":checked");
      var curtain_set_mini = $('#MaxiClick').is(":checked");


      var height_tag = $('[data-height-tag]').data('height-tag') ? parseInt($('[data-height-tag]').data('height-tag'),10) : 1;
      var width_tag = $('[data-width-tag]').data('width-tag') ? parseInt($('[data-width-tag]').data('width-tag'),10) : 1;
      var calc_type = $('[data-calculator]').data('calculator');
      var saum = $('input[name="saum"]:checked').val()|| 0;
      var konfektionspreis = $('#konfektionspreis').val()||0;



      if (height_tag !== 1) {
          if (height_value > height_tag) {
              $('#height').addClass('val-invalid').val(height_tag);
              setTimeout(() => {
                  $('#height').removeClass('val-invalid');
              }, 500);
              return;
          }
      }

      /* Check if any options are unselected and disable add to cart button (buy_custom_curtain) */
      if (width_value == 0 || width_value == null || width_value == undefined || width_value == "") {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(originalPrice * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(originalComparePrice * currentQuantity(), 2, '.', ''));

          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else if (height_value == 0 ) {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(originalPrice * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(originalComparePrice * currentQuantity(), 2, '.', ''));

          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else if (curtain_set_pair == false && curtain_set_piece == false) {
          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
    
      } else if (curtain_set_flach == false && curtain_set_einfache_falte == false && curtain_set_rundfalte == false && curtain_set_wave == false) {
          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else if (curtain_set_MaxiVS57 == false && curtain_set_Piccolo == false && curtain_set_mini == false) {
          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else if (!saum ) {
          if (buy_custom_curtain.length) {
              buy_custom_curtain.attr('disabled', 'disabled');
          }
      } else {
        $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(originalPrice * currentQuantity(), 2, '.', ''));
        $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(originalComparePrice * currentQuantity(), 2, '.', ''));

        buy_custom_curtain.removeAttr('disabled');


        var width = parseInt(width_value);
        var height = parseInt(height_value);
        var n_width = width / 100;
        var width_price = 0;
        var compare_width_price = 0;
        var new_height = 1;
        var curtain_factor = 1;

        // Define curtain_factor
        if(curtain_set_flach){
            curtain_factor = 1.5;
        }else if(curtain_set_einfache_falte){
        curtain_factor = 1.7
        } else if(curtain_set_rundfalte){
        curtain_factor = 2
        } else if(curtain_set_wave){
        curtain_factor = 2
        }
        console.log("breite", width);
        console.log('curtain_factor: ' + curtain_factor);
        
        width = (width * curtain_factor);
                
        if(curtain_set_piece){
            width = width + 10
            console.log("breite als set", width);
        }
        if(curtain_set_pair){
            width = width + 20
            console.log("breite als paar", width);
        }
        console.log("stoffmenge_berechnet",width);
        width_price = roundUp((((width)) / 100), 1);
        compare_width_price = roundUp((((width )) / 100), 1);
        

        // Final price for the width of curtain
        width_price = ( width_price * (parseFloat(originalPrice) + parseFloat(konfektionspreis )) );
        compare_width_price = ( compare_width_price * (parseFloat(originalComparePrice) + parseFloat(konfektionspreis)) );

        console.log('width_price:',width_price, 'konfektionspreis:', parseFloat(konfektionspreis) )

        var final_price = width_price;
        var compare_final_price = parseFloat(compare_width_price);

        console.log('final_price: ' + final_price);
        console.log('compare_final_price: ' + compare_final_price||0);

        $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(final_price * currentQuantity(), 2, '.', ''));
        $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(compare_final_price * currentQuantity(), 2, '.', ''));

        new_product_price = numberFormat(final_price, 2, '.', '');
          
      }
  });


  // Sell fabric calculator

    var fabric_price = currentPrice() / currentQuantity();
    console.log('fabric_price: ' + fabric_price);
    var compare_fabric_price = currentComparePrice() / currentQuantity();
    var origin_price = [];
    origin_price.push(fabric_price);
    var fabric_price_custom_price = 0;
    var isMass = $('[data-calc="Default-fabric"]').attr('data-hidden');

    if (isMass === '') {
        isMass = true;
    } else {
        isMass = false;
    }

    $('#configurator-fabric').on('click', function(e) {
        var buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain');
        var sell_as_fabric_text = $(this).find('> span');

        previousQuantity = 1;
        //$(".quantityPrice .quantity-input").val(1);

        $('.custom-options_wrap input[type="number"]').each(function() {
            $(this).val('');
        });


        $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(originalPrice * currentQuantity(), 2, '.', ''));
        $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(originalComparePrice * currentQuantity(), 2, '.', ''));


        if (sell_as_fabric_text.text() == 'Dieser Artikel kann auch als Einzelstoff bezogen werden.') {
            sell_as_fabric_text.text('Dieser Artikel kann auch als massgeschneiderter Vorhang bezogen werden.');
            verkauft_als_stoff = 'ja';
            
            if (inventory.inventory_policy === 'continue' && inventory.inventory_quantity <= 0) {
                $('[data-lieferzeit]').text("3 - 6 Wochen");
            } else {
                $('[data-lieferzeit]').text($('[data-lieferzeit]').data('lagerort'));
            }
        } else if (sell_as_fabric_text.text() == 'Dieser Artikel kann auch als massgeschneiderter Vorhang bezogen werden.') {
            sell_as_fabric_text.text('Dieser Artikel kann auch als Einzelstoff bezogen werden.');
            verkauft_als_stoff = 'nein';
            if (inventory.inventory_policy === 'continue' && inventory.inventory_quantity <= 0) {
                $('[data-lieferzeit]').text("3 - 6 Wochen");
            } else {
                $('[data-lieferzeit]').text($('[data-lieferzeit]').data('masslagerort'));
            }
            $("#width-fabric").val('');
            $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(origin_price[0] * currentQuantity(), 2, '.', ''));
            $('.purchase-details .modal_price .compate-at-price .money').text('CHF ' + numberFormat(compare_fabric_price * currentQuantity(), 2, '.', ''));

        }

        if (verkauft_als_stoff == 'nein') {
            $('.product-type').text('Vorhang nach Mass');
        } else {
            $('.product-type').text('Stoff');
        }

        buy_custom_curtain.attr('disabled', 'disabled');

        if ($('[data-calculator="default"]').attr('data-hidden') == '') {
            $('[data-calculator="default"]').removeAttr('data-hidden');
            $('[data-calc="Default-fabric"]').attr('data-hidden', '');
            isMass = true;
        } else {
            $('[data-calculator="default"]').attr('data-hidden', '');
            $('[data-calc="Default-fabric"]').removeAttr('data-hidden');
            isMass = false;
        }
  });



    $("#width-fabric").on('keyup change', function() {

      var buy_custom_curtain = $('button.custom_height_curtain, button.custom_width_curtain');
      var width = parseInt($('#width-fabric').val());

      console.log('origin_price[0]: ' + origin_price[0]);
      

      verkauft_als_stoff = 'ja';
      fabric_price_custom_price = (origin_price[0] * width) / 100;
      compare_fabric_price_custom_price = (compare_fabric_price * width) / 100;
      if (width == 0 || width == null || width == undefined || width == "" || isNaN(width)) {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(origin_price[0] * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(compare_fabric_price * currentQuantity(), 2, '.', ''));
          buy_custom_curtain.attr('disabled', 'disabled');
      } else {
          $('.purchase-details .modal_price .price .money').text('CHF ' + numberFormat(fabric_price_custom_price * currentQuantity(), 2, '.', ''));
          $('.purchase-details .modal_price .compare-at-price .money').text('CHF ' + numberFormat(compare_fabric_price_custom_price * currentQuantity(), 2, '.', ''));
          buy_custom_curtain.removeAttr('disabled');
      }

    });

  if (buy_custom_curtain.length) {
      buy_custom_curtain.on('click', function(event) {
          event.preventDefault();
          event.stopPropagation();

          if (!buy_custom_curtain.hasClass('disabled')) {
              var pid = $('[data-product-id]').data('product-id');
              var price = new_product_price;
              
              if ($('#length_bar').val() != '') {
                  var width_value = $('#length_bar').val();
              }
              if ($('#length').val() != '') {
                  var width_value = $('#length').val();
              }
              /* Schienenlänge in cm (dropdown) */
              if ($('#length_wave').val() != null) {
                var width_value = $('#length_wave').val();
              }

              var height_value = $('#height').val();

              if (verkauft_als_stoff == 'ja') {
                  width_value = $('#width-fabric').val();
                  console.log('width_value: ' + width_value);
                  price = fabric_price_custom_price;
                  console.log('price: ' + price);
              } else {
                  price = new_product_price;
              }
              console.log('new_product_price: ' + new_product_price);

            /*
              var inventory = JSON.parse($('[data-product-form]').attr('data-variant-inventory').replace('[', '').replace(']', ''));
            */
              if ((width_value && width_value < 50) || (height_value && height_value < 50)) {
                  var warning = '';
                  if ($('[data-height-tag]').data('height-tag') && height_value && height_value < 20) {
                      warning = `<p class="cart-warning__message animated bounceIn">Bitte geben Sie einen Wert zwischen 50 cm und ${ parseInt($('[data-height-tag]').data('height-tag').split(':')[1]) } cm ein</p>`;
                  } else {
                      warning = `<p class="cart-warning__message animated bounceIn">Bitte geben Sie einen Wert grösser als 50 cm ein</p>`;
                  }

                  $('.warning').remove();

                  $('[data-product-form]')
                      .find('.cart-warning')
                      .html(warning);

                  buy_custom_curtain
                      .removeAttr('disabled')
                      .removeClass('disabled');

                  buy_custom_curtain.find('.icon')
                      .removeClass('zoomOut')
                      .addClass('zoomIn');

                  buy_custom_curtain
                      .find('span:not(.icon)')
                      .text(buy_custom_curtain.data('label'))
                      .removeClass('zoomOut')
                      .addClass('zoomIn');
              } else {
                  var width_value_stoff = 0;
                  if ($('[data-calc]').data('hidden') == 'hidden') {
                      var width_tag = $('[data-width-tag]').data('width-tag') ? parseInt($('[data-width-tag]').data('width-tag').split(':')[1]) : 1;
                      var width_price_rounded = Math.round((width_value * curtain_factor) / width_tag);
                      //console.log('test lower part curtain_factor: ' + curtain_factor);
                      var new_height = Math.ceil((parseInt(height_value) + rapport) / 10) * 10;
                      width_value_stoff = width_price_rounded * new_height;
                  } else {
                      width_value_stoff = width_value;
                  }
                  
                 if (inventory.inventory_policy === 'deny' && (($('.quantityPrice input.quantity-input.quantity-element').val() * width_value_stoff) / 100) > inventory.inventory_quantity) {
                      const cartWarning = `<p class="cart-warning__message animated bounceIn">Der gewünschte Artikel ist in der gewünschten Menge leider nicht mehr bestellbar (maximal verfügbare Menge ${ inventory.inventory_quantity * 100 } cm)</p>`;

                      $('.warning').remove();

                      $('[data-product-form]')
                          .find('.cart-warning')
                          .html(cartWarning);

                      buy_custom_curtain
                          .removeAttr('disabled')
                          .removeClass('disabled');

                      buy_custom_curtain.find('.icon')
                          .removeClass('zoomOut')
                          .addClass('zoomIn');

                      buy_custom_curtain
                          .find('span:not(.icon)')
                          .text(buy_custom_curtain.data('label'))
                          .removeClass('zoomOut')
                          .addClass('zoomIn');
                  } else {
                      $('.cart-warning__message').remove();
                      $('[data-add-to-cart-trigger]').addClass('disabled');
                      $('.fabric-sample > button').addClass('disabled');
                      $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span').addClass('zoomOut');
                      $('[data-add-to-cart-trigger]').addClass('button_loading');

                      var stoffmenge_just_fabric_size = $('#width-fabric');


                      if (stoffmenge_just_fabric_size !== undefined || stoffmenge_just_fabric_size !== "undefined" || typeof stoffmenge_just_fabric_size !== undefined || typeof stoffmenge_just_fabric_size !== "undefined") {
                          if (stoffmenge_just_fabric_size.val()) {
                              stoffmenge = stoffmenge_just_fabric_size.val();
                          }
                      }

                      /* Check if inputs are disabled. Returns undefined if input is not disabled */
                      let gleiter = $("#gleiter_info").find("input[name='minMax']").prop('disabled');
                      //let second_gleiter = $("#Gleiter_info").find("input[name='second_gleiter']").prop('disabled');

    
                      let Abschluss = $("#Abschluss").val();
                      let Transparenz = $("#Transparenz").val();

                      let productData = {};
                      if ($('#length').val() != '') {
                          productData = {
                              pid: pid,
                              price: price,
                              isMass: isMass,
                              title: $('.product-title').text().trim(),
                              width: width_value,
                              height: height_value,
                              Vorhangschnitt: $('input[name="set"]:checked').length > 0 ? $('input[name="set"]:checked').attr('data-type') : 0,
                              Konfektionsart: $('input[name="accesories"]:checked').length > 0 ? $('input[name="accesories"]:checked').attr('data-type') : 0
                          }
                      }


                      /* Add info to productData array if input field is not disabled (undefined) */
                      if (!gleiter) {
                          productData['Gleiter'] = $('input[name="minMax"]:checked').length > 0 ? $('input[name="minMax"]:checked').attr('data-type') : 0
                      }

                      if ($('#Abschluss').val() != '') {
                          productData['saum'] = $('input[name="saum"]:checked').attr('data-type');
                      }
                      
                      productData['locale'] = Shopify.locale,
                      productData['title'] = $('.product-title').text().trim();
                      productData['pid'] = pid;
                      productData['price'] = price;
                      productData['Stoffmenge'] = stoffmenge
                      productData['original_product_url'] = window.location.href
                      if ($('#location').val() != '') {
                        productData['raumbezeichnung'] = $('#location').val();
                      }
                      var shop_domain = window.Shopify.shop;
                      var api_url = 'https://apps.onlineshop-experts.ch/joliv/functions/customvorhang.cfm';
                      $.ajax({
                          type: "POST",
                          data: JSON.stringify(productData),
                          contentType: "application/json",
                          dataType: "json",
                          headers: {
                            'x-shopify-shop': shop_domain
                          },
                          url: api_url,
                          always: function(data) {
                              console.log(data);
                          },
                          success: function(data) {

                              if (data.success === true) {
                                  addCreatedVariantToCart({
                                      data: {
                                          items: [{
                                              id: data.vid,
                                              quantity: $('.quantityPrice input.quantity-input.quantity-element').val(),
                                              properties: {}
                                          }]
                                      },
                                      success: function(data) {
                                          $('[data-add-to-cart-trigger]').removeClass('button_loading');
                                          $('[data-add-to-cart-trigger] svg.checkmark').addClass('checkmark-active');
                                          window.PXUTheme.jsAjaxCart.updateView();
                                          setTimeout(function() {
                                              $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span').hide();
                                          }, 300);
                                          setTimeout(function() {
                                              $('.header-cart.action-area__link').addClass('show-mini-cart');
                                              $('[data-add-to-cart-trigger]').removeClass('disabled');
                                              $('.fabric-sample > button').removeClass('disabled');
                                              $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span').removeClass('zoomOut');
                                              $('[data-add-to-cart-trigger] i, [data-add-to-cart-trigger] span').show();
                                              $('[data-add-to-cart-trigger] svg.checkmark').removeClass('checkmark-active');
                                          }, 2000);
                                      },
                                      error: handleCartError,
                                  });
                              } else {
                                  handleCartError(data);
                              }
                          },
                          error: handleCartError
                      });
                  }
              }
          }
      });
  }

  $('.fabric-sample > button').on('click', function(e) {

      e.preventDefault();
      e.stopPropagation();

      if (!$('.fabric-sample > button').hasClass('disabled')) {

          $('.cart-warning__message').remove();
          $('.fabric-sample > button').addClass('disabled');
          $('[data-add-to-cart-trigger]').addClass('disabled');
          $('.fabric-sample > button i, .fabric-sample > button span').addClass('zoomOut').hide();
          $('.fabric-sample > button').addClass('button_loading');

          var pid = $('[data-product-id]').data('product-id');
          var shop_domain = window.PXUTheme.theme_settings.domain;
          var api_url_sample = 'https://apps.onlineshop-experts.ch/joliv/functions/sample.cfm';

          $.ajax({
              type: "POST",
              data: JSON.stringify({
                  pid: pid,
                  title: $('.product-title').text().trim(),
                  original_product_url: window.location.href
              }),
              contentType: "application/json",
              dataType: "json",
              headers: {
                'x-shopify-shop': shop_domain
              },
              url: api_url_sample,
              always: function(data) {
                  console.log(data);
              },
              success: function(data) {
                  console.log(data);
                  if (data.success === true) {

                      addCreatedVariantToCart({
                          data: {
                              items: [{
                                  id: data.vid,
                                  quantity: $('input.quantity-input.quantity-element').val(),
                                  properties: {}
                              }]
                          },
                          success: function(data) {
                              $('.fabric-sample > button').removeClass('button_loading');
                              $('.fabric-sample > button').addClass('checkmark-animation');
                              $('.fabric-sample > button svg').addClass('checkmark-active');
                              window.PXUTheme.jsAjaxCart.updateView();
                              setTimeout(function() {
                                  $('.fabric-sample > button').removeClass('checkmark-animation');
                                  $('.fabric-sample > button svg').removeClass('checkmark-active');
                                  $('.fabric-sample > button').removeClass('disabled');
                                  $('[data-add-to-cart-trigger]').removeClass('disabled');
                                  buy_custom_curtain.removeClass('disabled');
                                  $('.fabric-sample > button span').removeClass('zoomOut').show();
                                  $('.fabric-sample > button span').show();
                              }, 2000);
                          },
                          error: handleCartError,
                      });
                  } else {
                      handleCartError(data);
                  }
              },
              error: handleCartError
          });

      }
  })
});
